import { createFileRoute } from '@tanstack/react-router';

import { DataSyncJobsPage } from '~/modules/dataSyncJobs/DataSyncJobsPage';

export const Route = createFileRoute('/(main)/settings/admin/data-sync/')({
  component: DataSyncJobsPage,
});
